import { useCallback, useEffect, useRef } from 'react';
import {
  asAppAppearanceId,
  saveUserUiAppearance,
  subscribeUserUiAppearance,
} from '../services/userAppearanceCloud';

/**
 * Gemeinsames Design über Firestore `userUiPrefs/{uid}`:
 * schreiben nur bei aktiver Settings-Änderung, sonst nur übernehmen.
 */
export function useSharedAppearanceSync(uid, setAppearance) {
  const lastAt = useRef(0);
  const appearanceRef = useRef(null);
  const setAppearanceRef = useRef(setAppearance);
  setAppearanceRef.current = setAppearance;

  useEffect(() => {
    if (!uid) {
      lastAt.current = 0;
      return;
    }
    lastAt.current = 0;
    return subscribeUserUiAppearance(uid, '', (prefs) => {
      if (lastAt.current > 0 && prefs.appearanceUpdatedAt <= lastAt.current) {
        return;
      }
      lastAt.current = Math.max(lastAt.current, prefs.appearanceUpdatedAt);
      const next = asAppAppearanceId(prefs.appearance);
      if (next && next !== appearanceRef.current) {
        appearanceRef.current = next;
        setAppearanceRef.current(next);
      }
    });
  }, [uid]);

  return useCallback(
    (appearance) => {
      if (!uid) return;
      const at = Date.now();
      lastAt.current = at;
      appearanceRef.current = appearance;
      void saveUserUiAppearance(uid, appearance, at);
    },
    [uid]
  );
}
